<template>
    <div class="order-box-left">
        <el-row :class="isMoreSearch ? 'order-search-more' : 'order-search'" :gutter="20">
            <el-col :span="4">
                <div class="grid-content bg-purple">
                    <div class="label">订单筛选</div>
                    <div style="width:100%; margin-top:4px">
                        <el-button type="primary" plain @click="emptySearch" size="small" class="search-btn">清空</el-button>
                        <el-button type="primary" plain @click="handleSearch" size="small" class="search-btn query-btn">查询</el-button>
                    </div>
                </div>
            </el-col>
            <el-col :span="4">
                <div class="grid-content bg-purple">
                    <div class="label">订货单号/国际单号</div>
                    <el-input v-model="searchData.orderNo" class="form-item" placeholder="请输入订单编号"/>
                </div>
            </el-col>
            <!-- <el-col :span="4">
                <div class="grid-content bg-purple">
                    <div class="label">支付单号</div>
                    <el-input v-model="searchData.payNo" class="form-item" placeholder="请输入支付单号"/>
                </div>
            </el-col> -->
            <el-col :span="4">
                <div class="grid-content bg-purple">
                    <div class="label">订单来源</div>
                    <el-select v-model="searchData.billSource" placeholder="请选择订单来源" >
                        <el-option v-for="item in orderSourceList" :key="item.key" :label="item.val" :value="item.key"></el-option>
                    </el-select>
                </div>
            </el-col>
            <el-col :span="4">
                <div class="grid-content bg-purple">
                    <div class="label">订单状态</div>
                    <el-select v-model="searchData.orderStatusList" collapse-tags multiple placeholder="请选择订单状态">
                        <el-option v-for="item in orderNewStatusTypeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </div>
            </el-col>
            <el-col :span="4">
                <div class="grid-content bg-purple">
                    <div class="label">订单渠道</div>
                    <el-select v-model="searchData.sourceChannelList" collapse-tags multiple placeholder="请选择订单渠道">
                        <el-option v-for="item in orderWayList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </div>
            </el-col>
            <el-col :span="8">
                <div class="grid-content bg-purple">
                    <div class="label">下单日期</div>
                    <el-date-picker v-model="orderTime" @change="orderTimeEvent" value-format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                </div>
            </el-col>
            <el-col :span="8">
                <div class="grid-content bg-purple">
                    <div class="label">付款日期</div>
                    <el-date-picker v-model="payTime" @change="payTimeEvent" value-format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
                </div>
            </el-col>
            <!-- <el-col :span="4">
                <div class="grid-content bg-purple">
                    <div class="label">商品分类</div>
                    <el-cascader ref="categorySec" style="width:100%" @change="categorySelect" :options="categoryList" :props="props" collapse-tags size="medium"></el-cascader>
                </div>
            </el-col> -->
            <el-col :span="4">
                <div class="grid-content bg-purple">
                    <div class="label">门店编码</div>
                    <search-input ref="bookmarkAutoStore" style="width:100%" :autoFocus="false" :data="buyerSortList" placeholder="请输入门店编码"
                        inputClassses="buyer-full" show-action show-pinned hideGroupTitle background-overlay
                        remainInputValue showName="outCode" @input="getStoreInfoList" @selected="addSelectStore" />
                </div>
            </el-col>
            <!-- <el-col :span="4">
                <div class="grid-content bg-purple">
                    <div class="label">商品名称</div>
                    <el-input v-model="searchData.skuName" class="form-item" placeholder="请输入商品名称"/>
                </div>
            </el-col> -->
            <!-- <el-col :span="4">
                <div class="grid-content bg-purple">
                    <div class="label">物料编码</div>
                    <el-input v-model="searchData.skuCode" class="form-item" placeholder="请输入物料编码"/>
                </div>
            </el-col> -->
            <!-- <el-col :span="4">
                <div class="grid-content bg-purple">
                    <div class="label">商品69码</div>
                    <el-input v-model="searchData.barCode" class="form-item" placeholder="请输入商品69码"/>
                </div>
            </el-col> -->
            <el-col :span="4">
                <div class="grid-content bg-purple">
                    <div class="label">支付方式</div>
                    <el-select v-model="searchData.paySource" placeholder="请选择支付方式" >
                        <el-option v-for="item in paySourceList" :key="item.key" :label="item.val" :value="item.key"></el-option>
                    </el-select>
                </div>
            </el-col>
            <el-col :span="4">
                <div class="grid-content bg-purple">
                    <div class="label">买家类型</div>
                    <!-- {{buyerTypeOptions}} -->
                    <el-select v-model="searchData.buyerType" placeholder="请选择买家类型" >
                        <el-option v-for="item in buyerTypes" :key="item" :label="item" :value="item"></el-option>
                    </el-select>
                </div>
            </el-col>
            <!-- <el-col :span="4">
                <div class="grid-content bg-purple search-input">
                    <div class="label">买家名称</div>
                    <el-input v-model="searchData.buyer" class="form-item" placeholder="请输入买家名称"/>
                </div>
            </el-col> -->
            <el-col :span="4">
                <div class="grid-content bg-purple">
                    <div class="label">买家手机号</div>
                    <!-- <el-input v-model="searchData.buyerPhone" maxlength="11" class="form-item" placeholder="请输入买家手机号"/> -->
                    <search-input style="width:100%" ref="bookmarkAutoBuyerPhone" :autoFocus="false" :data="phonelist" placeholder="请输入买家手机号"
                        inputClassses="buyer-full" show-action show-pinned hideGroupTitle background-overlay
                        remainInputValue showName="phone" @input="searchUserInfo" @selected="addSelectBuyerPhone" />
                </div>
            </el-col>
            <el-col :span="4">
                <div class="grid-content bg-purple">
                    <div class="label">买家客户编码</div>
                    <search-input style="width:100%" ref="bookmarkAutoBuyerCode" :autoFocus="false" :data="userInfoList" placeholder="请输入买家客户编码"
                        inputClassses="buyer-full" show-action show-pinned hideGroupTitle background-overlay
                        remainInputValue showName="outCode" @input="getClientInfoList" @selected="addSelectBuyerCode" />
                </div>
            </el-col>
            <!-- <el-col :span="4">
                <div class="grid-content bg-purple">
                    <div class="label">卖家姓名</div>
                    <el-input v-model="searchData.seller" class="form-item" placeholder="请输入卖家姓名"/>
                </div>
            </el-col>
            <el-col :span="4">
                <div class="grid-content bg-purple">
                    <div class="label">卖家手机号</div>
                    <el-input v-model="searchData.sellerPhone" maxlength="11" class="form-item" placeholder="请输入卖家手机号"/>
                </div>
            </el-col>
            <el-col :span="4">
                <div class="grid-content bg-purple">
                    <div class="label">卖家客户编码</div>
                    <search-input style="width:100%" ref="bookmarkAutoSellerCode" :autoFocus="false" :data="userInfoList" placeholder="请输入卖家客户编码"
                        inputClassses="buyer-full" show-action show-pinned hideGroupTitle background-overlay
                        remainInputValue showName="outCode" @input="getClientInfoList" @selected="addSelectSellerCode" />
                </div>
            </el-col> -->
            <el-col :span="4">
                <div class="grid-content bg-purple">
                    <div class="label">收货人姓名</div>
                    <el-input v-model="searchData.receiveName" class="form-item" placeholder="请输入收货人姓名"/>
                </div>
            </el-col>
            <el-col :span="4">
                <div class="grid-content bg-purple">
                    <div class="label">收货人手机号</div>
                    <el-input v-model="searchData.receivePhone" maxlength="11" class="form-item" placeholder="请输入收货人手机号"/>
                </div>
            </el-col>
            <el-col :span="8">
                <div class="grid-content bg-purple">
                    <div class="label">收货人地址</div>
                    <el-cascader style="width:100%" size="large" placeholder="请选择收货人地址" :options="options" v-model="selectedOptions" @change="handleChange"></el-cascader>
                </div>
            </el-col>
<!--            <el-col :span="4">-->
<!--                <div class="grid-content bg-purple">-->
<!--                    <div class="label">发货主体</div>-->
<!--                    <el-select v-model="searchData.bodyId" placeholder="请选择发货主体" >-->
<!--                        <el-option v-for="item in bodyTypeOptions" :key="item.id" :label="item.label" :value="item.id"></el-option>-->
<!--                    </el-select>-->
<!--                </div>-->
<!--            </el-col>-->
            <el-col :span="4">
                <div class="grid-content bg-purple">
                    <div class="label">币种</div>
                    <el-select v-model="searchData.currency" placeholder="请选择币种" >
                        <el-option v-for="item in currencyTypeList" :key="item.id" :label="item.label" :value="item.id"></el-option>
                    </el-select>
                </div>
            </el-col>
            <el-col :span="4">
                <div class="grid-content bg-purple">
                    <div class="label">PI号</div>
                    <el-input placeholder="请输入PI号" v-model="searchData.piNo"></el-input>
                </div>
            </el-col>
        </el-row>
        <div class="search-more" @click="moreSearchEvent">高级搜索</div>
    </div>
</template>

<script>
import store from './store.js';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import { Mandarin } from 'flatpickr/dist/l10n/zh.js';
import SearchInput from '@/modules/wms-manage/components/searchInput.vue';
import { OrderApi } from '@/modules/server-api/commodity-sys/order';
import {CommodityCategoryApi} from "@/modules/server-api/commodity-sys/category-manage";
import {WmsWarehouseApi, Mod_Warehouse_Types_Options} from '@/modules/server-api/wms-manage/warehouse';
import { FundManageApi } from "@/modules/server-api/fund/manage";
import { regionData, CodeToText, TextToCode } from 'element-china-area-data'
import {Mod_Stores} from "../server-api/Stores";
import {Mod_Clients} from "../server-api/Clients";
export default {
    props: {
        buyerTypes: {
            type: Array,
            default(){
                return {};
            }
        },
        tabIndex: {
            type: Number,
            default: 0,
        }
    },
    components: {
        flatPickr,SearchInput
    },
    // props: {
    //   dealerTypeList: Array,
    //   required: true
    // },
    mixins: [store],
    data() {
        return {
            props: { multiple: true },
            isMoreSearch: false,
            searchData: {
                piNo:'',//PI号
                orderNo: '', // 查询的订单编号
                payNo: '', //支付单号
                startTime: '', //下单开始日期
                endTime: '', //下单结束日期
                startPayTime: '', //付款开始日期
                endPayTime: '', //付款结束日期
                billSource: '', //订单来源
                orderStatusList: [], //订单状态
                sourceChannelList: [], //订单渠道
                categoryId: [], //商品分类
                buyerStoreCode: '', //门店编码
                skuCode: '', //物流编码
                skuName: '', //商品名称
                barCode: '', //商品69码
                paySource: '', //支付方式
                buyer:'', //买家名称id
                buyerCode: '', //买家编码
                buyerType: '', //买家类型
                buyerPhone: '', //买家手机号
                seller: '', //卖家名称id
                sellerCode: '', //卖家编码
                sellerPhone: '', //卖家手机号
                receiveName: '', //收货人姓名
                receivePhone: '', //收货人手机号
                province: '', //收货人省
                city: '', //收货人市
                area: '', //收货人区
                bodyId: '', //主体id
                currency: '', //币种
                dealerTypeList:[],
                tabIndex: this.tabIndex,
                isTab: false,
            },
            orderTime: '', //下单时间
            payTime: '', //支付时间
            categoryList: [], //商品分类列表
            bodyTypeOptions: [], //主体列表
            buyerOptions:[], //模糊搜索买家名称
            orderSearchInfo:[], //查询缓存
            searchTime:'',
            flatPickerConfig: {
                locale: Mandarin //日期控件中文
            },
            buyerSortList: [], //物料编码
            orderSourceList: [],  //订单来源
            paySourceList: [],  //支付方式
            options: regionData,  //地址信息
            selectedOptions: [],  //收货人地址
            userInfoList: [], //用户信息列表
            phonelist:[],
            currencyTypeList:[
              {id: 'RMB', label: 'RMB', symbol:'￥'},
              {id: 'USD', label: 'USD', symbol:'$'}
            ],
        };
    },
    created(){
    },
    async mounted() {
        // 详情返回时，把查询条件回显到页面上
        let searchInfo = sessionStorage.getItem('searchData') //本地存储的搜索info
        let data = JSON.parse(searchInfo) //本地存储的搜索info
        // console.log('查询条件1',data)
        await this.getOrderWayList(); //订单渠道
        await this.getNewStatusList();  //订单状态
        await this.getAccountSec();  //主体内容
        await this.getOrderSource();  //订单来源
        await this.getPaySource();  //支付方式
        await this.getTableData(); //商品分类
        // this.$nextTick(() => {
        //     if (this.$refs.collapse.$children) {
        //         this.$refs.collapse.$children.forEach(v => {
        //             v.toggleContent();
        //         });
        //     }
        // });
    },
    methods: {
        //高级搜索
        moreSearchEvent(){
            let that = this;
            that.isMoreSearch  = !that.isMoreSearch;
        },
        //省市区联动信息处理
        handleChange (addressArr) {
          if(addressArr.length > 0){
            this.searchData.province = CodeToText[addressArr[0]];
            this.searchData.city = CodeToText[addressArr[1]];

            let currArea = CodeToText[addressArr[2]] == this.allText ? this.otherText : CodeToText[addressArr[2]];
            this.searchData.area =  currArea;
          }
        },
        // 下单时间
        orderTimeEvent(e){
            let that = this;
            if(that.orderTime){
                that.searchData.startTime = that.orderTime[0];
                that.searchData.endTime = that.orderTime[1];
            }else{
                that.searchData.startTime = '';
                that.searchData.endTime = '';
            }
        },
        // 付款时间
        payTimeEvent(e){
            let that = this;
            if(that.payTime){
                that.searchData.startPayTime = that.payTime[0];
                that.searchData.endPayTime = that.payTime[1];
            }else{
                that.searchData.startPayTime = '';
                that.searchData.endPayTime = '';
            }
        },
        // 获取商品分类id
        categorySelect(array){
            let that = this;
            let categoryId = [];
            categoryId = array.map(item => { return item[2]})
            that.searchData.categoryId = categoryId;
        },

        // 查询
        handleSearch() {
          let searchData = this.searchData;
          console.log('查询项', searchData)
          this.$emit('handleSearch', searchData);
        },

        refreshBuyerType(buyerType, tabIndex){
        //   this.searchData.tabIndex = tabIndex;
          this.searchData.buyerType = '';
        },

        onChange(val) {
            this.$emit('onChangeTime');
        },

        //获取分类数据
        async getTableData(){
            let resp = await CommodityCategoryApi.getCategoryList({suggest: this.filterText});
            this.categoryList = [];
            let resData = resp.result;
            if(resData && resData.length > 0){
              this.categoryList = resData.map((item)=>{
                item.label = item.categoryName;
                item.value = item.id;
                if(item.children && item.children.length > 0){
                  item.children.map(oneChild => {
                      oneChild.label = oneChild.categoryName;
                      oneChild.value = oneChild.id;
                      if(oneChild.children && oneChild.children.length > 0){
                          oneChild.children.map(twoChild => {
                              twoChild.label = twoChild.categoryName;
                              twoChild.value = twoChild.id;
                          })
                      }
                  })
                }
                return item;
              })
            }
        },

        /**
         * 获取主体列表
         */
        async getAccountSec(){
            let that = this,
                params = {};
            params = {
                userId: '',
                bodyId: '',
            }
            let resp = await FundManageApi.editManageAccount(params);
            if(resp.code == 0 && resp.succ == 1){
                let result = resp.result;
                result.sdMainBodies.map(item => {
                    item.label = item.name
                })
                that.bodyTypeOptions = result.sdMainBodies;
            }
        },

        // 订单来源
        async getOrderSource() {
            let that = this;
            let resp = await OrderApi.getOrderSource({});
            if(resp.code == 0 && resp.succ == 1){
                let result = resp.result;
                that.orderSourceList = result;
            }
        },

        // 支付方式
        async getPaySource() {
            let that = this;
            let resp = await OrderApi.getPaySource({});
            if(resp.code == 0 && resp.succ == 1){
                let result = resp.result;
                that.paySourceList = result;
            }
        },

        // 模糊搜索买家名称
        async searchInputSuggest(e){
            this.buyerOptions = []
            this.searchData.buyer = e === '' ?  '' : this.searchData.buyer;
            let suggest = e.trim()
            // let suggest = e == 'undefined' ? '': e.trim()
            // let thisSearchTime = new Date().getTime();
            // this.searchTime = thisSearchTime;
            let res = await OrderApi.getBuyerName({search:suggest});
            // if(thisSearchTime >= this.searchTime){
                this.buyerOptions = res.result;
            // }
        },

        // 模糊搜索客户编码
        async getClientInfoList(e){
            this.userInfoList = [];
            let suggest = e;
            let params = {
                pageNo: 1,
                pageSize: 20,
                data: {
                    outCode: suggest
                }
            }
            let res = await OrderApi.getClientInfoList(params);
            console.log(res);
            if(res.result && res.result.list){
                this.userInfoList = res.result.list;
            }
        },

        // 模糊搜索门店编码
        async getStoreInfoList(e){
            this.buyerSortList = []
            let suggest = e;
            let params = {
                pageNo: 1,
                pageSize: 20,
                data: {
                    outCode: suggest
                }
            }
            let res = await OrderApi.getStoreInfoList(params);
            console.log(res);
            if(res.result && res.result.list){
                this.buyerSortList = res.result.list;
            }
        },
        // 模糊搜索买家卖家信息
        async searchUserInfo(e){
            console.log(e);
            this.phonelist = [];
            let suggest = e;
            let params = {
                pageNo: 1,
                pageSize: 20,
                data: {
                    phone: suggest
                }
            }
            let res = await OrderApi.getInfoList(params);
            console.log(res);
            if(res.result && res.result.list){
                this.phonelist = res.result.list;
            }
        },
        // 选择买家客户编码
        addSelectBuyerCode(item){
            this.searchData.buyerCode = item.outCode;
        },
        // 选择卖家客户编码
        addSelectSellerCode(item){
            this.searchData.sellerCode = item.outCode;
        },
        // 选择门店编码
        addSelectStore(item){
            this.searchData.buyerStoreCode = item.outCode;
        },
         // 选择买家电话
        addSelectBuyerPhone(item){
            this.searchData.buyerPhone = item.outCode;
        },
        // 清空筛选条件
        emptySearch(){
            this.searchData = {
                orderNo: '', // 查询的订单编号
                payNo: '', //支付单号
                startTime: '', //下单开始日期
                endTime: '', //下单结束日期
                startOrcTime: '', //出库开始日期
                endOrcTime: '', //出库结束日期
                startSendTime: '', //发货开始日期
                endSendTime: '', //发货结束日期
                startPayTime: '', //付款开始日期
                endPayTime: '', //付款结束日期
                billSource: '', //订单来源
                orderStatusList: [], //订单状态
                sourceChannelList: [], //订单渠道
                categoryId: [], //商品分类
                buyerStoreCode: '', //门店编码
                skuCode: '', //物流编码
                skuName: '', //商品名称
                barCode: '', //商品69码
                paySource: '', //支付方式
                buyer:'', //买家名称id
                buyerName:'',//买家名称
                buyerCode: '', //买家编码
                buyerType: '', //买家类型
                buyerPhone: '', //买家手机号
                seller: '', //卖家id
                sellerCode: '', //卖家编码
                sellerPhone: '', //卖家手机号
                receiveName: '', //收货人姓名
                receivePhone: '', //收货人手机号
                province: '', //收货人省
                city: '', //收货人市
                area: '', //收货人区
                bodyId: '', //主体id
                currency: '', //币种
                dealerTypeList:[],
                isTab: false,
                tabIndex: 0,
            };
            this.selectedOptions = [];
            this.orderTime= ''; //下单时间
            this.payTime= ''; //支付时间
            this.$refs['bookmarkAutoStore'].searchQuery ='';
            this.$refs['bookmarkAutoBuyerCode'].searchQuery = '';
            this.$refs['bookmarkAutoBuyerPhone'].searchQuery = '';
            // this.$refs['bookmarkAutoSellerCode'].searchQuery = '';
            // this.$refs['categorySec'].checkedValue =[];

            this.handleSearch();

        },

    },
    watch: {
        "searchData.orderNo"(val){
            this.searchData.orderNo = val;
        },
        "searchData.invoiceNo"(val){
            this.searchData.invoiceNo = val;
        },
        "searchData.payNo"(val){
            this.searchData.payNo = val;
        },
        orderTime(val){
            this.orderTime = val;
        },
        orcTime(val){
            this.orcTime = val;
        },
        sendTime(val){
            this.sendTime = val;
        },
        payTime(val){
            this.payTime = val;
        },
        "searchData.billSource"(val){
            this.searchData.billSource = val;
        },
        "searchData.orderStatusList"(val){
            this.searchData.orderStatusList = val;
        },
        "searchData.sourceChannelList"(val){
            this.searchData.sourceChannelList = val;
        },
        "searchData.skuCode"(val){
            this.searchData.skuCode = val;
        },
        "searchData.skuName"(val){
            this.searchData.skuName = val;
        },
        "searchData.barCode"(val){
            this.searchData.barCode = val;
        },
        "searchData.paySource"(val){
            this.searchData.paySource = val;
        },
        "searchData.buyerType"(val){
            this.searchData.buyerType = val;
        },
        "searchData.receivePhone"(val){
            this.searchData.receivePhone = val;
        },
        selectedOptions(val){
            this.selectedOptions = val;
        },
        "searchData.bodyId"(val){
            this.searchData.bodyId = val;
        },
        "searchData.currency"(val){
            this.searchData.currency = val;
        },
    }
};
</script>

<style lang="scss" scoped>
@import './order.scss';
.order-box-left {
    background: rgb(255, 255, 255);
    padding: 10px 20px 0;
    text-align: center;
    // display: flex;
    // flex-wrap: wrap;
    // width: 170px;
    // height: 100%;
    .order-search{
        width: 100%;
        height: 80px;
        overflow: hidden;
        margin: 0 !important;
    }
    .order-search-more{
        height: auto;
        margin: 0 !important;
    }
    .search-more{
        display: inline-block;
        padding: 10px 10px 0 10px;
        color: #409EFF;
        cursor: pointer;
        margin: 0 auto;
    }
    .flatpickr-input {
        width: 100%;
    }
    .el-col{
        height: 64px;
        margin-bottom: 10px;
    }
    .top-search {
        @include flex-mixin(row, center, space-between);
        display: block !important;
        height: 80px;
        border-bottom: 1px solid rgb(235, 234, 234);
    }
    /deep/ .v-select {
        width: 100%;
    }
    .collapse {
        /deep/ .el-collapse-item {
            border: none !important;
            .el-collapse-item--header {
                padding: 12px 0 !important;
            }
            .con-content--item {
                padding: 0;
            }
        }
    }
    .filterWidth{
        width: 170px;
    }
    .item {
        padding: 12px 12px 0;
    }
    .label {
        height: 26px;
        line-height: 26px;
        font-size: 14px;
        font-weight: 500;
        color: #14151b;
        text-align: left;
    }
    .form-item {
        width: 100%;
        height: 38px;
    }
}
.search-btn {
    width: 46%;
    margin: 0 2%;
}
</style>
<style>
.search-input .vs-con-input-label{
    width: 100%;
}
.el-select{
    width: 100%;
}
.order-box-left .el-date-editor--daterange.el-input, .el-date-editor--daterange.el-input__inner, .el-date-editor--timerange.el-input, .el-date-editor--timerange.el-input__inner {
    width: 100%;
}
.order-box-left .el-date-editor .el-range-separator{
   width: 10%;
}
.order-box-left .el-cascader__tags .el-tag:nth-child(1){
    width: 55%;
}
.vs-tabs--li button.vs-tabs--btn{
    z-index: 0;
}
</style>
